import  { HttpClient }  from "../../services/api/httpclient.service";


export class ExerciseQuestionsService extends HttpClient {

    constructor() {
        super()
    }

    public async fetchExerciseQuestions(exerciseId: number){
      try {
        const response = await this.get(`/data/display_exercise_questions?exercise_id=${exerciseId}`);
        return await response; // Return the first (and only) exercise
      } catch (error) {
        console.error("Error fetching exercise:", error);
        return null;
      }
    }   

    public async getExerciseQuestionHistory(exerciseId: number){
      try {
        const response = await this.post(`/data/get_exercise_questions_history?exercise_id=${exerciseId}`);
        return await response;
      } catch (error) {
        console.error("Error fetching exercise:", error);
        return null;
      }  
    }

    public async upsertExerciseHistory(payload: {
      selected_exercise_id: number;
      selected_question_id: string;
      selected_step_id?: number | null;
      is_completed_steps?: boolean | null;
      is_completed_question?: boolean | null;
    }) {
      try {
        const response = await this.post(`/data/upsert_exercise_history`, payload);
        return response;
      } catch (error) {
        console.error("Error updating exercise history:", error);
        return null;
      }
    }

    public async fetchExerciseStepsHistory(questionId: number){
      try {
        const response = await this.post(`/data/get_exercise_steps_history?question_id=${questionId}`);
        return await response;
      } catch (error) {
        console.error("Error fetching exercise steps history:", error);
        return null;
      }
    }   
    public async getExerciseHistory(){
      try {
        const response = await this.post(`/data/get_exercise_history`);
        return await response;
      } catch (error) {
        console.error("Error fetching exercise history:", error);
        return null;
      }  
    }
}